module.exports = __webpack_public_path__ + "static/media/angry-face-with-horns-svgrepo-com.451333be.svg";